module.exports = __webpack_public_path__ + "img/elo-v2.svg";